export default ( { fileName, template, data } ) => {
  const rows = data.map(row => {
    return template.map(c => c.render(row)).join(';');
  });
  rows.unshift(template.map(c => c.header).join(';'));

  let csvContent = '\uFEFF' + rows.join("\n");
  let encodedUri = "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);

  let link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  setTimeout(() => link.remove(), 0);
}
